import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from '@mui/material';

const EditCommercial = ({
  editedProperty,
  handleInputChange,
  typeInfo,
}) => {
  const isOffice = typeInfo.isOffice;
  const isShowroom = typeInfo.isShowroom;
  const isRetailShop = typeInfo.isRetailShop;
  const isWarehouse = typeInfo.isWarehouse;
  const isPlot = typeInfo.isPlot;
  const isFarmhouse = typeInfo.isFarmhouse;

  const bhkOptions = ['1', '2', '3', '4', '5', '6', '6+'];
  const furnishTypes = ['fully-furnished', 'semi-furnished', 'un-furnished'];
  const hubs = ['IT Park', 'Business Park', 'Others'];
  const ownerships = ['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* OFFICE FIELDS */}
      {isOffice && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Size <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                name="property_size"
                type="number"
                value={editedProperty?.property_size || ''}
                onChange={handleInputChange}
                placeholder="Enter property size"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="built_up_area"
                type="number"
                value={editedProperty?.built_up_area || ''}
                onChange={handleInputChange}
                placeholder="Enter built-up area"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="zone_type"
                value={editedProperty?.zone_type || ''}
                onChange={handleInputChange}
                placeholder="Enter zone type"
                size="small"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>

          {/* Available Floors Section */}
          <Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Available Floors <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Total Floors
                </Typography>
                <TextField
                  fullWidth
                  name="total_floors"
                  type="number"
                  value={editedProperty?.total_floors || ''}
                  onChange={handleInputChange}
                  placeholder="Enter total floors"
                  size="small"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Select Floor
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="select_floor"
                    value={editedProperty?.select_floor || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled>Select Floor</MenuItem>
                    {[...Array(20)].map((_, i) => (
                      <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                        {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Ownership
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="ownership"
                    value={editedProperty?.ownership || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Ownership</em></MenuItem>
                    {ownerships.map((own) => (
                      <MenuItem key={own} value={own}>{own}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Hub
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="hub"
                    value={editedProperty?.hub || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Hub</em></MenuItem>
                    {hubs.map((hub) => (
                      <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* SHOWROOM & RETAIL SHOP FIELDS */}
      {(isShowroom || isRetailShop) && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Size <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                name="property_size"
                type="number"
                value={editedProperty?.property_size || ''}
                onChange={handleInputChange}
                placeholder="Enter property size"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="built_up_area"
                type="number"
                value={editedProperty?.built_up_area || ''}
                onChange={handleInputChange}
                placeholder="Enter built-up area"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="carpet_area"
                type="number"
                value={editedProperty?.carpet_area || ''}
                onChange={handleInputChange}
                placeholder="Enter carpet area"
                size="small"
                                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>

          {/* Available Floors Section */}
          <Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Available Floors <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Total Floors
                </Typography>
                <TextField
                  fullWidth
                  name="total_floors"
                  type="number"
                  value={editedProperty?.total_floors || ''}
                  onChange={handleInputChange}
                  placeholder="Enter total floors"
                  size="small"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Select Floor
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="select_floor"
                    value={editedProperty?.select_floor || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled>Select Floor</MenuItem>
                    {[...Array(20)].map((_, i) => (
                      <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                        {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Ownership
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="ownership"
                    value={editedProperty?.ownership || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Ownership</em></MenuItem>
                    {ownerships.map((own) => (
                      <MenuItem key={own} value={own}>{own}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Hub
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="hub"
                    value={editedProperty?.hub || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Hub</em></MenuItem>
                    {hubs.map((hub) => (
                      <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* WAREHOUSE FIELDS */}
      {isWarehouse && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Size <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                name="property_size"
                type="number"
                value={editedProperty?.property_size || ''}
                onChange={handleInputChange}
                placeholder="Enter property size"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="zone_type"
                value={editedProperty?.zone_type || ''}
                onChange={handleInputChange}
                placeholder="Enter zone type"
                size="small"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="built_up_area"
                type="number"
                value={editedProperty?.built_up_area || ''}
                onChange={handleInputChange}
                placeholder="Enter built-up area"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="carpet_area"
                type="number"
                value={editedProperty?.carpet_area || ''}
                onChange={handleInputChange}
                placeholder="Enter carpet area"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>

          {/* Available Floors Section */}
          <Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Available Floors <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Total Floors
                </Typography>
                <TextField
                  fullWidth
                  name="total_floors"
                  type="number"
                  value={editedProperty?.total_floors || ''}
                  onChange={handleInputChange}
                  placeholder="Enter total floors"
                  size="small"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Select Floor
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="select_floor"
                    value={editedProperty?.select_floor || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled>Select Floor</MenuItem>
                    {[...Array(20)].map((_, i) => (
                      <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                        {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Ownership
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="ownership"
                    value={editedProperty?.ownership || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Ownership</em></MenuItem>
                    {ownerships.map((own) => (
                      <MenuItem key={own} value={own}>{own}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Hub
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="hub"
                    value={editedProperty?.hub || ''}
                    onChange={handleInputChange}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Hub</em></MenuItem>
                    {hubs.map((hub) => (
                      <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* COMMERCIAL PLOT FIELDS */}
      {isPlot && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Size <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                  fullWidth
                  name="property_size"
                  type="number"
                  value={editedProperty?.property_size || ''}
                  onChange={handleInputChange}
                  placeholder="Enter size"
                  size="small"
                  sx={{ flex: 1, '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
                <FormControl size="small" sx={{ minWidth: 100 }}>
                  <Select
                    name="property_size_units"
                    value={editedProperty?.property_size_units || 'Sq.Yards'}
                    onChange={handleInputChange}
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="Sq.Yards">Sq.Yards</MenuItem>
                    <MenuItem value="Acres">Acres</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="zone_type"
                value={editedProperty?.zone_type || ''}
                onChange={handleInputChange}
                placeholder="Enter zone type"
                size="small"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  name="ownership"
                  value={editedProperty?.ownership || ''}
                  onChange={handleInputChange}
                  displayEmpty
                  sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                >
                  <MenuItem value=""><em>Select Ownership</em></MenuItem>
                  {ownerships.map((own) => (
                    <MenuItem key={own} value={own}>{own}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="length"
                type="number"
                value={editedProperty?.length || ''}
                onChange={handleInputChange}
                placeholder="Enter length"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                name="width"
                type="number"
                value={editedProperty?.width || ''}
                onChange={handleInputChange}
                placeholder="Enter width"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>
        </>
      )}

      {/* COMMERCIAL FARMHOUSE FIELDS */}
      {isFarmhouse && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                BHK <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  name="bhk"
                  value={editedProperty?.bhk || ''}
                  onChange={handleInputChange}
                  displayEmpty
                  sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                >
                  <MenuItem value="" disabled>Select BHK</MenuItem>
                  {bhkOptions.map((bhk) => (
                    <MenuItem key={bhk} value={bhk}>{bhk} BHK</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  name="furnish_type"
                  value={editedProperty?.furnish_type || ''}
                  onChange={handleInputChange}
                  displayEmpty
                  sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                >
                  <MenuItem value="" disabled>Select Furnish Type</MenuItem>
                  {furnishTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                name="built_up_area"
                type="number"
                value={editedProperty?.built_up_area || ''}
                onChange={handleInputChange}
                placeholder="Enter built-up area"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Size <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                name="property_size"
                type="number"
                value={editedProperty?.property_size || ''}
                onChange={handleInputChange}
                placeholder="Enter property size"
                size="small"
                InputProps={{
                  endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Grid>
          </Grid>
        </>
      )}

      {/* Common Fields for All Commercial Types */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            name="property_name"
            value={editedProperty?.property_name || ''}
            onChange={handleInputChange}
            placeholder="Enter building name"
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Area Name <span style={{ color: '#d32f2f' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            name="area_name"
            value={editedProperty?.area_name || ''}
            onChange={handleInputChange}
            placeholder="Enter area name"
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Complete Address <span style={{ color: '#d32f2f' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            name="full_address"
            value={editedProperty?.full_address || ''}
            onChange={handleInputChange}
            placeholder="Enter complete address"
            size="small"
            multiline
            rows={3}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            fullWidth
            name="description"
            value={editedProperty?.description || ''}
            onChange={handleInputChange}
            placeholder="Enter description"
            size="small"
            multiline
            rows={3}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional - YouTube, Facebook, WhatsApp, Instagram)</span>
          </Typography>
          <TextField
            fullWidth
            name="youtube_link"
            type="url"
            value={editedProperty?.youtube_link || ''}
            onChange={handleInputChange}
            placeholder="Enter social media link"
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EditCommercial;

